import * as React from 'react';
import { SVGProps } from 'react';

const IconIncidentSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m12 0 1.913 8.027L24 3l-6.75 8.019 5.25 1.731-6 2.25 1.5 9-6-7.59-4.3 3.84V15L0 14.25l6.75-3.231-3-5.769 6 1.5L12 0Z" />
  </svg>
);
export default IconIncidentSizeM;
